import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject, takeUntil } from 'rxjs';
import { EditActiveRequestModel } from 'src/app/models/inventory.model';
import { InventoryService } from 'src/app/services/inventory.service';
import { HeaderService } from '../header/header.service';
import { SnackbarComponent } from '../snackbar/snackbar.component';

@Component({
  selector: 'app-duplicate-sku',
  templateUrl: './duplicate-sku.component.html',
  styleUrls: ['./duplicate-sku.component.scss']
})
export class DuplicateSkuComponent implements OnInit,OnDestroy {
  loading: boolean = false;
  private destroy$ = new Subject<void>();
  spin: boolean = false
  skus:any[]=[];
  account;
  keys:string[]=[];
  skuList:any[]=[];
  amountPerPage:number = 100;
  startRow:number=0;
  loadingSkus: boolean = true;

  constructor(
  @Inject(MAT_DIALOG_DATA) public data,
  public dialogRef: MatDialogRef<DuplicateSkuComponent>,
  private inventoryService: InventoryService,
  private snackBar: MatSnackBar,
  private headerService:HeaderService
  ){ 
    this.headerService.accountsSelected.pipe(takeUntil(this.destroy$)).subscribe((e) => {
      this.account = e;
    })
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  ngOnInit(): void {
    this.data.title = this.data.title + '' + `(${this.data.account})`
    this.getSkuWithDuplicateAsin(true);
  }

  getSkuWithDuplicateAsin(reset = false){
    this.skuList = [];
    this.loadingSkus=true;
    if (!reset) {
      this.startRow += this.amountPerPage;
    } else {
      this.startRow = 0;
    }
    const payload = {
      account:this.data.account,
      startRow:this.startRow,
      endRow:this.startRow + this.amountPerPage
    }
     this.inventoryService.GetSkuWithDuplicateAsin(payload).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res:any) => {
        if(res){
        this.skuList = res;
        this.skus.push(...res);              
        this.setSkuWithType();
        this.loadingSkus=false;
      }
      },
     error: (err) => {
      this.loadingSkus=false;  
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 4000,
          horizontalPosition: 'center',
          data: {
            title: 'Something went wrong',
            action: 'Dismiss',
            type: 'error',
          },
        }
      );
     }
   });
  }

  setSkuWithType(): void {
    this.skuList?.forEach((res,index)=>{
      const skuList=res.skus ? res.skus?.split(',') : [];
      res.skus=[];
      if(skuList.length){
        skuList.forEach((sku:string)=>{
          let obj=sku.split(":");
          let uid=(obj[0]+ ((Math.random() * Math.pow(36, 4)) | 0).toString(36)).slice(-4);
          res.skus.push({sku:obj[0],type:obj[1],active:true,id:uid,accountSkuId:obj[4]})
        })
      }
    })
  }

  getInactiveSkus(){
    this.loading=true;
    let activeSkus=[];
    this.skus.forEach((res)=>{
     let skus= res.skus?.filter((sku)=> !sku.active)
     if(skus.length) activeSkus.push(...skus);
    })
    if(activeSkus.length){
      let splittedSkus = activeSkus.reduce((currentValue, next) => {
        if (!currentValue.hasOwnProperty(next.type)) {
          currentValue[next.type] = [];
        }
        currentValue[next.type].push(next.accountSkuId);
        return currentValue;
      }, {});
      this.keys=Object.keys(splittedSkus);
      this.keys.forEach((type,index)=>{
        this.setActiveSku(type,splittedSkus[type],index)
      })
    } else{
      this.loading=false;
      this.close();
    }    
  }

  setActiveSku(type,accountSkuId,index){
    const data: EditActiveRequestModel = {
      account: this.account[0],
      active: false,
      accountSkuId: accountSkuId,
      fulfillmentType: type,
    };

    this.inventoryService.EditActiveById(data).pipe(takeUntil(this.destroy$)).subscribe({
     next: (res) => {
      if(index === this.keys.length-1){
        this.loading=false;
        this.snackBar.openFromComponent(SnackbarComponent,
          {
            duration: 4000,
            horizontalPosition: 'center',
            data: {
              title: "Skus have been inactivated successfully.",
              action: 'Dismiss',
              type: 'success',
            },
          }
        );
        this.dialogRef.close("Confirm");
      } 
    },
    error: (err) => {
      if(index === this.keys.length-1) this.loading=false;
      this.snackBar.openFromComponent(SnackbarComponent,
        {
          duration: 4000,
          horizontalPosition: 'center',
          data: {
            title: err.error.errors[0],
            action: 'Dismiss',
            type: 'error',
          },
        }
      );
     }
   });
  }

  action(e?) {
    if(e === 'Save'){
      this.getInactiveSkus();
    }else {
      this.skus.forEach((res)=>{
        res.skus?.forEach((sku)=>{
          sku.active=true;
        })
      })
      this.close()
    }
  }

  close() {
    this.dialogRef.close();
  }


}
